import { DateInput, useFormContext } from "@4uhub/lib4uhub";
import { Box, Grid, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { CheckboxesSection } from "./CheckboxesSection";
import { TServicePeriodForm } from "./servicePeriodSchema";

const translationPath = "page.4uDlist.generationRule.servicePeriod.";

export const ServicePeriodFields = memo(() => {
  const { t } = useTranslation();

  const { setValue, control, formState } = useFormContext<TServicePeriodForm>();

  const hasServiceTypeError = !!formState.errors.serviceType;
  const serviceTypeError = formState.errors.serviceType;

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <DateInput
            name="startDate"
            label={t(translationPath + "start_date")}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <DateInput name="endDate" label={t(translationPath + "end_date")} />
        </Grid>
      </Grid>

      <Box sx={{ pl: 2, mt: 5 }}>
        <Grid
          container
          spacing={2}
          sx={(t) => ({
            pr: 3,
            pl: 1,
            py: 3,
            border: `1px solid ${
              hasServiceTypeError ? t.palette.error.main : t.palette.divider
            }`,
            borderRadius: 2,
          })}
        >
          <Grid item xs={12}>
            <Typography variant="body1" fontWeight="bold">
              {t(translationPath + "service_types")}
            </Typography>
          </Grid>

          {hasServiceTypeError && (
            <Grid item xs={12}>
              <Typography variant="caption" color="error">
                {t(serviceTypeError?.message!)}
              </Typography>
            </Grid>
          )}

          <CheckboxesSection />
        </Grid>
      </Box>
    </>
  );
});
